import { nl2br } from '@/npm/nl2br.js';
import React from 'react';
import boolToTextFilter from '../../../utils/boolToTextFilter.js';
import { formatLotParamDateTime } from '../../../utils/formatLotParamDateTime.js';
import { formatLotParamNumber } from '../../../utils/formatLotParamNumber.js';
import { ParamType } from './LotParam.type.js';
import { ParamTypeMultiple } from './LotParam.type.js';
import { ParamTypeDateTime } from './LotParam.type.js';
import { ParamTypeNumber } from './LotParam.type.js';
import { ParamMultipleTypes } from './ParamMultipleTypes.js';
import Text from '../../_shared/Text/Text.js';
import styles from './LotParamValue.module.scss';

export interface ParamValueProps {
  type: ParamType | null;
  value: any;
  level?: number;
}

const ParamTypeName = {
  STRING: 'string',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  DATETIME: 'datetime',
  ONE_OF_TYPES: 'one_of_types',
  SOME_OF_TYPES: 'some_of_types',
  MULTIPLE_TYPES: 'multiple_types',
};

/**
 * Компонент формы редактирования значения дополнительного параметра лота
 */
export const LotParamValue: React.FC<ParamValueProps> = ({
  type,
  value,
  level = 0,
}) => {
  switch (type?.type) {
    case ParamTypeName.STRING:
      return <div>{nl2br<string>(value)}</div>;
    case ParamTypeName.NUMBER: {
      return <div>{formatLotParamNumber(type as ParamTypeNumber, value)}</div>;
    }
    case ParamTypeName.BOOLEAN:
      return (
        <div>
          <div>{boolToTextFilter(value)}</div>
        </div>
      );
    case ParamTypeName.DATETIME: {
      return (
        <div>{formatLotParamDateTime(type as ParamTypeDateTime, value)}</div>
      );
    }
    case ParamTypeName.ONE_OF_TYPES: {
      const { children } = type as ParamTypeMultiple;
      const childIndex = value?.[0];
      const child = children?.[childIndex];
      return child ? (
        <div>
          <Text>{child.label}</Text>
          <div className={styles.offset}>
            <LotParamValue
              type={child.child}
              value={value?.[1]?.[childIndex]}
              level={level + 1}
            />
          </div>
        </div>
      ) : null;
    }
    case ParamTypeName.SOME_OF_TYPES: {
      return (
        <ParamMultipleTypes
          type={type as ParamTypeMultiple}
          className={level > 0 ? styles.offset : ''}
        >
          {({ label, child }, index) => {
            const isSelected =
              Array.isArray(value?.[0]) && value[0].includes(index);
            return isSelected ? (
              <div>
                <Text>{label}</Text>
                <div className={styles.offset}>
                  <LotParamValue
                    type={child}
                    value={value?.[1]?.[index]}
                    level={level + 1}
                  />
                </div>
              </div>
            ) : null;
          }}
        </ParamMultipleTypes>
      );
    }
    case ParamTypeName.MULTIPLE_TYPES: {
      return (
        <ParamMultipleTypes
          type={type as ParamTypeMultiple}
          className={level > 0 ? styles.offset : ''}
        >
          {({ label, child }, index) => (
            <div>
              <Text>{label}</Text>
              <div className={styles.offset}>
                <LotParamValue
                  type={child}
                  value={value?.[index]}
                  level={level + 1}
                />
              </div>
            </div>
          )}
        </ParamMultipleTypes>
      );
    }
    default:
      return null;
  }
};
